// icons
import * as I from './icons';
// ui
import { IconWrapper } from '../../ui';
//////////////////////////////////////////////////

const Icon = props => {
  const {
    w,
    h,
    ml,
    mr,
    mt,
    name,
    color,
    width,
    cursor,
    height,
    handleClick,
    hoveredOpacity,
    hoveredTransform,
  } = props;

  const iconProps = { w, h, color };

  const styles = {
    ml,
    mr,
    mt,
    width,
    cursor,
    height,
    hoveredOpacity,
    hoveredTransform,
  };

  return (
    <IconWrapper {...styles} onClick={handleClick}>
      {I[name](iconProps)}
    </IconWrapper>
  );
};

export default Icon;
